import * as ScreenOrientation from 'expo-screen-orientation';
import * as Device from 'expo-device';
import { useEffect } from 'react';
import { Platform } from 'react-native';

const setOrientation = async () => {
    if (Platform.OS === 'web') return;

    const orientationToUse =
        Device.deviceType === Device.DeviceType.TABLET || Device.deviceType === Device.DeviceType.DESKTOP
            ? ScreenOrientation.OrientationLock.LANDSCAPE
            : ScreenOrientation.OrientationLock.PORTRAIT;

    const isSupported = await ScreenOrientation.supportsOrientationLockAsync(orientationToUse);
    if (isSupported) {
        await ScreenOrientation.lockAsync(orientationToUse);
    }
};

/**
 * Locks the device to the preferred orientation.
 *
 * For:
 *  - Non-Native/web: Nothing
 *  - Tablets and Desktops: Landscape
 *  - Phones: Portrait
 */
export const useLockDeviceOrientation = () => {
    useEffect(() => {
        setOrientation();
    }, []);
};
